import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { DateService } from '../../shared/services/date.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  dashboardData: any;
  activeTab: 'transactions' | 'risk' | 'ops' = 'transactions';
  selectedFromDate: any;
  selectedToDate: any;
  fromTimestamp: number | null = null;
  toTimestamp: number | null = null;

  barChartSettings = {
    showXAxis: true,
    showYAxis: true,
    gradient: true,
    showLegend: false,
    showXAxisLabel: true,
    xAxisLabel: 'Country',
    showYAxisLabel: true,
    yAxisLabel: 'Amount',
    data: []
  };

  transactionsPieChart = {
    data: []
  };

  colorScheme: Color = {
    name: "custom",
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      "#0d30da", "#ff7043", "#00bcd4", "#5e35b1", "#66bb6a"
    ],
  };

  isTransactions = true;

  constructor(private _api: ApiService, private _dateService: DateService, private _auth: AuthService) { }

  ngOnInit() {
    const vm = this;
    vm.getDashboardData();
    vm.getDashboardChartData();
  }

  onToggle() {
    this.isTransactions = !this.isTransactions;
  }

  getDashboardData() {
    const vm = this;
    const reqObj = {};
    
    // Get partnerId from auth service
    const user = vm._auth.getUser();
    if (!user || !user.partnerId || !user.partnerId._id) {
      return;
    }
    
    let apiUrl = `/partners/auth/dashboard`;
    if (this.fromTimestamp && this.toTimestamp) {
      apiUrl += `?createdAtdatePickerRange=${this.fromTimestamp},${this.toTimestamp}`;
    }
    
    vm._api.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.dashboardData = res.data;
      }
    });
  }

  isActive(tab: 'transactions' | 'risk' | 'ops') {
    const vm = this;
    return vm.activeTab === tab;
  }

  setActiveTab(tab: 'transactions' | 'risk' | 'ops') {
    this.activeTab = tab;
    this.selectedFromDate = null;
    this.selectedToDate = null;
    this.fromTimestamp = null;
    this.toTimestamp = null;
  }


  getDashboardChartData() {
    const vm = this;
    const reqObj = {};
    
    // Get partnerId from auth service
    const user = vm._auth.getUser();
    if (!user || !user.partnerId || !user.partnerId._id) {
      return;
    }
    
    let apiUrl = `/partners/auth/dashboard-graph`;
    if (this.fromTimestamp && this.toTimestamp) {
      apiUrl += `?createdAtdatePickerRange=${this.fromTimestamp},${this.toTimestamp}`;
    }
    
    vm._api.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.barChartSettings.data = res.data.spentSum;
        vm.transactionsPieChart.data = res.data.transactionsCount
      }
    });
  }

  onDateSelected(result: { fromDate: any, toDate: any }) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    if (vm.selectedFromDate && vm.selectedToDate) {
        vm.fromTimestamp = vm.selectedFromDate ;
        vm.toTimestamp = vm.selectedToDate; 
    } else {
      vm.fromTimestamp = null;
      vm.toTimestamp = null;
    }
    
    vm.getDashboardData();
    vm.getDashboardChartData();
  }

}